import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import IngkaLoading, { LoadingBall } from "@ingka/loading";
import { ErrorBoundary, ErrorDisplay, NOW_IT_LINK, loadAndInjectFonts, } from "@pdpp/lib-react";
import { useGetUserPermissions } from "../../api/oppAuthApi";
import { Forecast } from "../../components/forecast/Forecast";
import { BasenameContext } from "../../services/basenameContext";
import { i18n } from "../../utils/language/i18n";
import { addLanguageBundlesParcel, getSupportedLanguage, } from "../../utils/language/language";
const queryClient = new QueryClient();
export const ForecastParcel = ({ forecastApi, orgNode, countryCode, language, }) => {
    const [isLoading, setIsLoading] = useState(true);
    const lang = getSupportedLanguage(language);
    useEffect(() => {
        const initializeParcel = async () => {
            try {
                await Promise.all([
                    loadAndInjectFonts(lang),
                    addLanguageBundlesParcel(lang).catch((error) => {
                        console.error("Failed to load language bundles for parcel:", error);
                    }),
                ]);
            }
            catch (error) {
                console.error("Failed to initialize parcel:", error);
            }
            finally {
                setIsLoading(false);
            }
        };
        initializeParcel();
    }, [lang]);
    if (isLoading) {
        return (_jsx(IngkaLoading, { text: "", labelTransitions: true, children: _jsx(LoadingBall, {}) }));
    }
    return (_jsx(_Fragment, { children: _jsx(I18nextProvider, { i18n: i18n, children: _jsx(ErrorBoundary, { fallback: ErrorDisplay, videoUrl: "/images/error-video.mp4", helpdeskUrl: NOW_IT_LINK, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(BasenameContext.Provider, { value: "", children: _jsx("div", { className: "forecast-parcel", children: _jsx(ForecastParcelInner, { forecastApi: forecastApi, orgNode: orgNode, countryCode: countryCode }) }) }) }) }) }) }));
};
const ForecastParcelInner = ({ forecastApi, orgNode, countryCode }) => {
    useGetUserPermissions(forecastApi);
    return (_jsx(Forecast, { forecastApi: forecastApi, orgNode: orgNode, countryCode: countryCode, noPadding: true }));
};
//# sourceMappingURL=ForecastParcel.js.map